import React, { createContext, useContext, useMemo, useReducer } from 'react';

import {
  incident,
  incidents,
} from '../../services/incidents/incidents.service';
import incidentsReducer, {
  FAILURE_INCIDENTS,
  FAILURE_INCIDENT_BY_ID,
  REQUEST_INCIDENTS,
  REQUEST_INCIDENT_BY_ID,
  SUCCESS_INCIDENTS,
  SUCCESS_INCIDENT_BY_ID,
} from './incidents.reducer';

export const IncidentsContext = createContext<any>(null);

const initialVehicles = {
  incidents: [],
  incident: {},
  loading: false,
  loadingPool: [],
};

const IncidentsProvider = ({ ...props }) => {
  const [state, dispatch] = useReducer(incidentsReducer, initialVehicles);

  const getIncidents = async () => {
    dispatch({
      type: REQUEST_INCIDENTS,
    });

    try {
      const res = await incidents();
      dispatch({
        type: SUCCESS_INCIDENTS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FAILURE_INCIDENTS,
      });
    }
  };

  const getIncidentById = async (id: number) => {
    dispatch({
      type: REQUEST_INCIDENT_BY_ID,
    });

    try {
      const res = await incident(id);
      dispatch({
        type: SUCCESS_INCIDENT_BY_ID,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FAILURE_INCIDENT_BY_ID,
      });
    }
  };

  const IncidentsValue = useMemo(
    () => ({
      ...state,
      getIncidents,
      getIncidentById,
    }),
    [state]
  );

  return <IncidentsContext.Provider value={IncidentsValue} {...props} />;
};

export const useIncidentsContext = () => useContext(IncidentsContext);

export default IncidentsProvider;
